<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="radio-main">
    <label>
      {{ label }}
      <input type="radio" v-model="pSelected" :name="name" :disabled="isDisabled" :value="label" @change="radioChanged" ref="radioInput">
    </label>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
      pSelected: null,
    };
  },
  props: {
    // Public Properties
    label: { type: String, default: 'Radio Button' }, // Set the label of the radio button that will be displayed on the right of the radio button
    name: { type: String, default: '' }, // used to define different groups of radio buttons, so the force only one radio button to be selected per group
    isDisabled: { type: Boolean, default: false }, // To disable the radio button and disallow selection

    // Public events
    // @radioChanged - fired when a radio button is selected by the user, but not when changed programatically, listen to this to get the latest selected button
  },
  methods: {
    radioChanged: function(event) {
      this.$emit("radioChanged", this.label, event);
    },

    // Public Methods
    selectRadio: function() {
      this.pSelected = this.label;
    },
    clearRadio: function() {
      this.pSelected = null;
    },
    setFocus: function() {
      this.$refs.radioInput.focus();
    },
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.radio-main > label {
  margin: 0;
  cursor: pointer;

  > input { // actual radio button
    opacity: 0; // hide actual radio button
    cursor: pointer;
  }

  > input:disabled { // actual radio button when input is disabled
    cursor: default;
  }

  &::before { // add pseudo radio button
    border: 1px solid black;
    border-radius: 10px;
    height: 13px;
    width: 13px;
    content: '\00A0'; // no-break space, used to force text-align and line-height to take effect
    text-align: center; // so that the pseudo radio button and the label are vertically aligned
    line-height: 11px;
    display: inline-block;
    cursor: pointer;
  }

  &:has(> input:checked)::before { // pseudo radio button when input is checked
    // content: '•'; // tried a few methods to get the appearance correct
    // content: '⦿'; // couldn't get these to align properly
    // content: radial-gradient(black 3px, transparent); // the only way was to use a static image, because of the limitations of css' content property
    content: url(https://dsmlib.logistics.systems/Icons/bullet.png); // the image will need to be resized if the height and width of the button is changed
  }

  &:has(> input:focus)::before { // pseudo radio button when input is focued
    box-shadow: 0 0 0 3px rgb(168, 199, 250);
  }

  &:has(> input:disabled)::before { // pseudo radio button when input is disabled
    border: 1px solid rgb(200, 200, 200);
    cursor: default;
  }

  &:has(> input:disabled) { // label when input is disabled
    opacity: 0.5;
    cursor: default;
  }
}

</style>